import React from 'react';
import './HomepageTable.scss';
import { EventDTO } from '../../../models/common/EventDTO';
import moment from 'moment';
import {
  EmptyOddsBlock,
  getOdds,
  teamTypes,
} from '../../../components/ExchEventsTable/ExchInplayEventsTable';
import OddButton from '../../../components/ExchOddButton/ExchOddButton';
import {
  liveImagesMap,
  SportIconMapInplay,
  SportIdByName,
} from '../../../util/stringUtil';
import LiveTvIcon from '@material-ui/icons/LiveTv';
import { useHistory } from 'react-router';
import { getSportLangKeyByName } from '../../../util/localizationUtil';
import { RootState } from '../../../models/RootState';
import { useSelector } from 'react-redux';

type InplayEventsObj = {
  sportId: string;
  sportName: string;
  sportSlug: string;
  events: EventDTO[];
};

interface HomepageTableProps {
  event: any;
  selectedSport: any;
}

const HomepageTable: React.FC<HomepageTableProps> = ({
  event,
  selectedSport,
}) => {
  const history = useHistory();
  const eventList = event;
  const langData = useSelector((state: RootState) => state.common.langData);

  const dateCellWidth = '15%';
  const matchCellWidth = '40%';
  const matchOddsCellWidth = '15%';

  const handleEventChange = (iEvent: InplayEventsObj, event: EventDTO) => {
    const competitionSlug = event.competitionName
      ? event.competitionName
          .toLocaleLowerCase()
          .replace(/[^a-z0-9]/g, ' ')
          .replace(/ +/g, ' ')
          .trim()
          .split(' ')
          .join('-')
      : 'league';
    history.push(
      `/exchange_sports/${iEvent.sportSlug}/${competitionSlug}/${
        event.eventSlug
      }/${btoa(`${event.sportId}:${event.competitionId}:${event.eventId}`)}`
    );
  };

  return (
    <div className="table-container">
      <table className="custom-table">
        <thead>
          <tr className="table-heading-row-ctn">
            <th className="table-title-ctn">
              <img
                className="sport-inplay-icon"
                src={SportIconMapInplay[selectedSport.id]}
                alt={selectedSport.name + ' icon'}
              />
              {langData?.[`${getSportLangKeyByName(selectedSport.name)}`]}
            </th>
            <th></th>
            <th>1</th>
            <th>X</th>
            <th>2</th>
          </tr>
        </thead>
        <tbody className='table-body'>
          {eventList &&
            eventList.length > 0 &&
            eventList.slice(0, 3).map(
              (
                eventObj,
                index // Slice to display only the first 3 events
              ) => (
                <tr
                  onClick={() => handleEventChange(event, eventObj)}
                  key={index}
                >
                  <td
                    style={{
                      width: dateCellWidth,
                    }}
                  >
                    <div className="table-date-ctn">
                      <div>
                        <img
                          className="live-img"
                          src={
                            eventObj.status == 'IN_PLAY'
                              ? liveImagesMap[selectedSport.id]
                              : ''
                          }
                          alt=""
                        />
                      </div>
                      <div className="date-txt">
                        {moment(eventObj?.openDate).format('hh:mm A')} |{' '}
                        {moment(eventObj?.openDate).format('DD MMM')}
                      </div>
                    </div>
                  </td>
                  <td style={{ width: matchCellWidth }}>
                    <div className="match-ctn">
                      <div>{eventObj.eventName}</div>
                      <div className="custom-button-ctn">
                        {eventObj.enablePremium && (
                          <button key={'P'} className="custom-button">
                            {'P'}
                          </button>
                        )}
                        {eventObj.enablePremium && (
                          <button key={'MO'} className="custom-button">
                            {'MO'}
                          </button>
                        )}

                        {eventObj.enableBookmaker && (
                          <button key={'B'} className="custom-button">
                            {'B'}
                          </button>
                        )}
                        {eventObj.enableFancy && (
                          <button key={'F'} className="custom-button">
                            {'F'}
                          </button>
                        )}
                      </div>
                    </div>
                  </td>

                  {teamTypes.map((teamType, index) => (
                    <td
                      style={{ width: matchOddsCellWidth }}
                      className={`odd-cell`}
                      key={teamType} // Key added to ensure proper rendering for teamType
                    >
                      {eventObj?.matchOdds ? (
                        getOdds(eventObj, teamType) ? (
                          <div className="odds-block">
                            {getOdds(eventObj, teamType).map((odd) => (
                              <div
                                className={`odds-cell-common ${
                                  odd.type === 'back-odd'
                                    ? `back-odd-cell ${
                                        +odd.price > 0 ? '' : 'disabled'
                                      }`
                                    : `lay-odd-cell ${
                                        +odd.price > 0 ? '' : 'disabled'
                                      }`
                                }`}
                                key={odd.price} // Added key for each odd
                              >
                                <OddButton
                                  mainValue={odd.price}
                                  subValue={odd.size}
                                  oddType={
                                    odd.type === 'back-odd'
                                      ? 'back-odd'
                                      : 'lay-odd'
                                  }
                                  disable={eventObj.matchOdds.status
                                    .toLowerCase()
                                    .includes('suspended')}
                                  valueType="matchOdds"
                                  showSubValueinKformat={true}
                                  onClick={() => null}
                                  subValueClass="size"
                                />
                              </div>
                            ))}
                          </div>
                        ) : (
                          <EmptyOddsBlock />
                        )
                      ) : (
                        <EmptyOddsBlock />
                      )}
                    </td>
                  ))}
                </tr>
              )
            )}
        </tbody>
      </table>
    </div>
  );
};

export default HomepageTable;
